// Single source of truth for social profiles.
// `featured` marks the curated subset shown in the Contact section's "Elsewhere"
// block; the Linktree page (/linktree) renders the full list.
export const SOCIALS = [
  {
    key: "github",
    label: "GitHub",
    handle: "@Abw-0l0",
    href: "https://github.com/Abw-0l0",
    featured: true,
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    handle: "Abdul Basit Iqbal",
    href: "https://www.linkedin.com/in/abdul-basit-iqbal-9503a81bb/",
    featured: true,
  },
  {
    key: "x",
    label: "X",
    handle: "@Abw_0l0",
    href: "https://x.com/Abw_0l0",
    featured: true,
  },
  {
    key: "facebook",
    label: "Facebook",
    handle: "Abw0l0",
    href: "https://www.facebook.com/Abw0l0/",
  },
  {
    key: "instagram",
    label: "Instagram",
    handle: "@abw_0l0",
    href: "https://www.instagram.com/abw_0l0/",
  },
  {
    key: "soundcloud",
    label: "SoundCloud",
    handle: "abw_0l0",
    href: "https://soundcloud.com/user-480073501-636813106",
  },
];
